import application from 'application/application';

import template from './unmark-email.template.html';

import controller from './unmark-email.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.unmarkEmail', {
			url: '/cancelamento-envio-email?CodigoCancelamento',
			views: {
				root: {
					templateUrl: template,
					controller
				}
			},
			data: {
				documentTitle: 'Cancelamento Envio Email'
			}
		});
	}
]);
